import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';
import {Translate} from 'react-redux-i18n';
import {DOCUMENT_STATE} from 'front-onceforall-core/dist/utils/documents';
import {Icon} from 'front-onceforall-core';
import * as snackbarsActions from '../../../../actions/snackbars';
import {captureError} from '../../../../utils/log';
import documentService from '../../../../services/document/DocumentService';
import DocumentsStats from '../../../documentsStats';
import constructDataElement from '../../../documentsStats/utils/constructDataElement';
import {recordGAEvent} from '../../../../utils/analytics';

function DocumentsView(props) {
  const dispatch = useDispatch();
  const exportParams = useSelector(state => ({
    userId: state.user.id,
    locale: state.i18n.locale
  }));

  function handleDownloadExport() {
    recordGAEvent('BUYER_DOSSIER', 'Export all suppliers folder for all my sirets');
    documentService.createDocumentExport(exportParams)
      .then(() => dispatch(snackbarsActions.addSuccess(<Translate value="message.exportRequestSuccess"/>)))
      .catch(error => {
        captureError('Error while requesting global subcontractors dossier', error);
        dispatch(snackbarsActions.addError(<Translate value="error.generic"/>));
      });
  }

  const data = [
    constructDataElement(props.percentages[DOCUMENT_STATE.VALID], '#3fd2b0', 'project.documentsStates.VALID', true),
    constructDataElement(props.percentages[DOCUMENT_STATE.ALMOST_EXPIRED], '#ecc430', 'project.documentsStates.ALMOST_EXPIRED', true),
    constructDataElement(props.percentages[DOCUMENT_STATE.MISSING], '#fb3958', 'project.documentsStates.MISSING', false)
  ];

  const actions = (
    <button
      type="button"
      className="small secondary flex-container"
      onClick={handleDownloadExport}
    >
      <Icon icon="folder-download"/>
      <Translate value="subcontractor.export"/>
    </button>
  );

  return (
    <DocumentsStats
      data={data}
      loading={props.loading}
      error={props.error}
      actions={actions}
      title="globalDashboard.documents"
    />
  );
}

DocumentsView.propTypes = {
  percentages: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.string
};

export default DocumentsView;
